import styled from 'styled-components';

export const QrLinkContainer = styled.div`
    display: flex;

    .qr-link__title {
        margin-bottom: 12px;
        margin-top: 8px;
    }

    .qr-link__text {
        color: ${(props) => props.theme.palette.textLight};

        a {
            color: ${(props) => props.theme.palette.primaryA1};
        }
    }

    .qr-code {
        margin-right: 20px;
        min-height: 80px;
        min-width: 80px;

        img {
            height: 100%;
        }
    }

    .button-close {
        position: absolute;
        top: 16px;
        right: 16px;
    }
`;
